import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';
import { AuthSessionService } from '../auth-session.service';

/**
 * NoAuthGuard — prevents already-authenticated users from accessing public auth pages
 * (login, otp, forgot-password, reset-password).
 * If session is valid → redirect to dashboard.
 * If session is invalid → allow access to the auth page.
 */
export const NoAuthGuard: CanActivateFn = async (route: ActivatedRouteSnapshot) => {
    if (route.routeConfig?.path?.includes('pda-disburesement')) {
        return true;
    }

    const authSessionService = inject(AuthSessionService);
    const router = inject(Router);

    const isValid = await authSessionService.ensureSessionState();

    if (isValid) {
        return router.createUrlTree(['/layout']);
    }

    return true;
};
